module.exports = __webpack_public_path__ + "static/img/ercode.6f9d8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ercode.png
// module id = hk/z
// module chunks = 1